import { render, staticRenderFns } from "./BookDetails.vue?vue&type=template&id=5c01b78e&scoped=true&"
import script from "./BookDetails.vue?vue&type=script&lang=js&"
export * from "./BookDetails.vue?vue&type=script&lang=js&"
import style0 from "./BookDetails.vue?vue&type=style&index=0&id=5c01b78e&lang=less&scoped=true&"
import style1 from "./BookDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c01b78e",
  null
  
)

export default component.exports